export const PRIMARY = "primary";
export const SECONDARY = "secondary";
export const WARNING = "warning";
export const LINK = "link";
